module.exports = __webpack_public_path__ + "static/media/advisory-landing-mobile.0e815922.png";